import { useContext, useEffect, useState } from 'react';
import { LandingService } from '../../services';
import { Loading, Home } from '../../components';
import { ProfileContext } from '../../contexts';
import { registerView } from '../../helpers';

export const HomePage = () => {
  const [data, setData] = useState(null);
  const { profile } = useContext(ProfileContext);

  useEffect(() => {
    LandingService.getData().then(setData).catch(console.error);
  }, []);

  useEffect(() => {
    if (typeof profile?.deadline?.isDeadlineOver !== 'boolean') return;
    registerView(profile);
  }, [profile?.deadline?.isDeadlineOver]);

  if (!data) {
    return (
      <div className="App-content App-loading-content">
        <Loading />
      </div>
    );
  }

  return (
    <div className="App-content">
      <div className="App-row">
        <Home data={data} />
      </div>
      <div className="App-row">
        <p>
          <br />
        </p>
      </div>
    </div>
  );
};
